<div class="subscription-container" id="holding-container">
  <!-- <iframe 
      *ngIf="stripeUrl"
      sandbox="allow-scripts allow-same-origin allow-popups"
      width="700" 
      height="600" 
      [src]="stripeUrl">
    </iframe> -->

  <div *ngIf="initialLoading" class="initial-loading">
    {{ 'auth.welcomeStripe.loading' | translate }}
    <div class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>

  <div class="container-subs-list" *ngIf="!initialLoading">
    <!-- <span class="welcome-text"
      >Welcome! To proceed choose the best subscription plan for your
      organisation, or wait for someone to invite you to theirs.</span
    > -->

    <span class="welcome-text">
      {{ 'auth.welcomeStripe.welcomeText' | translate }}<br /><b>{{
        'auth.welcomeStripe.freeTrial' | translate
      }}</b>
      {{ 'auth.welcomeStripe.noCreditCard' | translate }}
    </span>

    <div class="container-heading">
      <label>{{ 'auth.welcomeStripe.choosePlan' | translate }}</label>

      <ops-annual-monthly-switch
        [value]="selectedInterval"
        (valueChange)="onIntervalChange($event)"
      ></ops-annual-monthly-switch>

      <ops-currency-switch
        [value]="selectedCurrency"
        (valueChange)="onCurrencyChange($event)"
      ></ops-currency-switch>
    </div>

    <div class="flex flex-column mt-25 justify-center ci align-center m-auto">
      <div class="container-subscriptions">
        <ops-subscription-card
          *ngFor="let plan of subscriptionPlans"
          [plan]="plan"
          [showMonthly]="showingMonthly"
          (selectPlan)="onSelectPlan($event)"
          (changePlan)="onChangePlan()"
          [selectedCurrency]="selectedCurrency"
          (cancelSubscription)="onCancelSubscription($event)"
        />
      </div>
    </div>
  </div>
</div>
